import { schema } from 'normalizr';

interface State {
    ban_id: string;
    client_url: string;
    client_name: string;
    primary_contact_id: string;
    primary_contact_name: string;
    status: string;
    city: string;
    outlet_name: string;
    assigned_to: string;
    list_id: string;
    list_name: string;
    date_added: string;
    last_activity: string;
    is_dnc: boolean;
    is_lead: boolean;
    is_expired: boolean;
    total_subscribers?: number;
    total_eligible?: number;
    unread: number;
}

export const listSchema = new schema.Entity('smartlist', undefined, {
    idAttribute: 'primary_contact_id',
    processStrategy: value => {
        return {
            ...value,
            unread: 0,
            timestamp: new Date(value.last_activity).getTime(),
        };
    }
});

export const SMARTLISTTYPES = {
    ADD: 'SMARTLIST.ADD',
    INCOMING: 'SMARTLIST.INCOMING',
    READ: 'SMARTLIST.READ'
};

export const SMARTLISTFILTERS = {
    DEFAULT: 'SMARTLISTFILTERS.DEFAULT',
    UPDATE: 'SMARTLISTFILTERS.UPDATE'
};

export const initialFilter = {
    month: ('0' + (new Date().getMonth() + 1)).slice(-2),
    year: new Date().getFullYear().toString(),
};

export const initialState = {};

export const listReducer = (state: State, action) => {
    switch (action.type) {
        case SMARTLISTTYPES.ADD:
            return {
                ...action.data
            };
        case SMARTLISTTYPES.INCOMING:
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    unread: state[action.id].unread + 1
                }
            };
        case SMARTLISTTYPES.READ:
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    unread: 0
                }
            };
        default:
            return state;
    }
};

export const filterReducer = (state: any, action) => {
    switch (action.type) {
        case SMARTLISTFILTERS.UPDATE:
            return { ...action.payload };
        case SMARTLISTFILTERS.DEFAULT:
            return initialFilter;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/sections/SmartList/reducer.ts